import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import { IParkerProfileDetail, IParkerProfileDetailForExport } from '../../interfaces';
import { formatDate } from '@angular/common';

export class ParkerExportTransform {
  constructor(parkerStateService: ParkerStateService) {
    this.parkerStateService = parkerStateService;
  }

  public parkerStateService: ParkerStateService;

  //This transforms raw data from a db query results into a format specifically for binding with the grid
  //the primary transformation converts boolean to Yes/No strings
  public TransformRawParkerList(parkerProfileList: IParkerProfileDetail[]): IParkerProfileDetailForExport[] {
    let preppedData: IParkerProfileDetailForExport[] = [];
    let ii: number;

    // try
    // {

    for (ii = 0; ii < parkerProfileList.length; ii++) {
      let aParker: IParkerProfileDetailForExport = {} as IParkerProfileDetailForExport;
      let source: IParkerProfileDetail = parkerProfileList[ii];

      aParker.rowId = ii;
      aParker.active = source.active;
      aParker.activeAsBoolean = source.activeAsBoolean;
      aParker.addressLine = source.addressLine;
      aParker.additionalCardCount = source.additionalCardCount;
      aParker.additionalEmailCount = source.additionalEmailCount;
      aParker.additionalEmails = source.additionalEmails;
      aParker.additionalEmailsCount = source.additionalEmailsCount;
      aParker.additionalEmailsExist = source.additionalEmailsExist;
      aParker.additionalVehicles = source.additionalVehicles;
      aParker.address = source.address;
      aParker.addressLine = source.addressLine;
      aParker.baseAmount = source.baseAmount;
      aParker.cardNumber = source.cardNumber;
      aParker.city = source.city;
      aParker.comments = source.comments;
      aParker.company = source.company;
      aParker.companyId = source.companyId;
      aParker.companyName = source.companyName;
      aParker.companyStartDate = source.companyStartDate;
      aParker.contractCount = source.contractCount;
      aParker.deliveryType = source.deliveryType;
      aParker.hasContract = source.hasContract;
      aParker.emailAddress = source.emailAddress;

      aParker.endDate = source.endDate;
      aParker.existingRecord = source.existingRecord;
      aParker.firstName = source.firstName;
      aParker.group = source.group;
      aParker.isAcePortal = source.isAcePortal == true ? 'Yes' : 'No';
      aParker.isExpiredRate = this.IsRateExpired(aParker.parkerId);
      aParker.isPortalAutoPay = source.isPortalAutoPay == true ? 'Yes' : 'No';
      aParker.isPortalCreditCardOnFile = source.isPortalCreditCardOnFile == true ? 'Yes' : 'No';
      aParker.isTermDateSet = source.isTermDateSet;
      aParker.lastName = source.lastName;
      aParker.longCardNumber = source.longCardNumber;
      aParker.lotNumber = source.lotNumber;
      aParker.massUpdateTargetFlag = source.massUpdateTargetFlag;
      aParker.myAceEmailCount = source.myAceEmailCount;
      aParker.parkerId = source.parkerId;
      aParker.parkerPayType = source.parkerPayType;
      aParker.payType = source.payType;
      aParker.paymentType = source.paymentType;
      aParker.phone = source.phone;
      aParker.rate = source.rate;
      aParker.rateDescription = source.rateDescription;
      aParker.rateDescriptionSummary = source.rateDescriptionSummary;
      aParker.rateDisplay = source.rateDisplay;
      aParker.rateNumber = source.rateNumber;
      aParker.rateNumberAsString = source.rateNumberAsString;
      aParker.rateType = source.rateType;
      aParker.stallNumber = source.stallNumber;
      aParker.stallType = source.stallType;
      aParker.standardRateType = source.standardRateType;
      aParker.startDate = source.startDate;
      aParker.startDateDisplay = source.startDateDisplay;
      aParker.state = source.state;
      aParker.tax = source.tax;
      aParker.taxExempt = source.taxExempt == true ? 'Yes' : 'No';
      aParker.tenantId = source.tenantId;
      aParker.userName = source.userName;
      aParker.vehicleColor = source.vehicleColor;
      aParker.vehicleCount = source.vehicleCount;
      aParker.vehicleLicense = source.vehicleLicense;
      aParker.vehicleMake = source.vehicleMake;
      aParker.vehicleModel = source.vehicleModel;
      aParker.vehicleState = source.vehicleState;
      aParker.zipCode = source.zipCode;
      aParker.spaceEmailAddress = this.GetSpaceEmailForEntityId(source.parkerId);
      aParker.spaceUserId = this.GetSpaceUserIdForEntityId(source.parkerId);

      if (source.endDate.toString() == '0001-01-01T00:00:00') aParker.endDateDisplay = '';
      else {
        const format = 'MM/dd/yyyy';
        const myDate = source.endDate;
        const locale = 'en-US';
        aParker.endDateDisplay = formatDate(myDate, format, locale);
      }

      preppedData.push(aParker);
    }

    // }
    // catch(err){
    //   console.error('Error: ' + err);
    // }
    return preppedData;
  }

  IsRateExpired(entityId: string): string {
    let rateExpired: string = '--';
    let ii: number = 0;

    // 20241211 :: Ken Moss
    // entityId's being passed in were undefined.
    // Backlog Issue:  https://aceparking.backlog.com/board/L2?selectedIssueKey=L2-462
    if (entityId != undefined && entityId != null) {
      for (ii = 0; ii < this.parkerStateService.parkerExpiredRates.length; ii++) {
        if (this.parkerStateService[ii].parkerExpiredRates.parkerId == entityId) {
          rateExpired = 'Yes';
          break;
        }
      }
    }

    return rateExpired;
  }

  GetSpaceUserIdForEntityId(entityId: string): string {
    let spaceUserId: string = '';

    spaceUserId = '--';

    let ii: number = 0;

    if (this.parkerStateService.spaceUsersForLotNumber == null) {
      spaceUserId = null;
    } else {
      for (ii = 0; ii < this.parkerStateService.spaceUsersForLotNumber.length; ii++) {
        if (this.parkerStateService.spaceUsersForLotNumber[ii].entityId === entityId) {
          spaceUserId = this.parkerStateService.spaceUsersForLotNumber[ii].spaceUserId.toLocaleString();
        }
      }

      spaceUserId = spaceUserId.replace(',', '');
    }

    if (spaceUserId === null) spaceUserId = '--';

    return spaceUserId;
  }

  GetSpaceEmailForEntityId(entityId: string): string {
    let spaceEmail: string = '';

    spaceEmail = '--';

    let ii: number = 0;

    if (this.parkerStateService.spaceUsersForLotNumber == null) {
      spaceEmail = null;
    } else {
      for (ii = 0; ii < this.parkerStateService.spaceUsersForLotNumber.length; ii++) {
        if (this.parkerStateService.spaceUsersForLotNumber[ii].entityId === entityId) {
          spaceEmail = this.parkerStateService.spaceUsersForLotNumber[ii].emailAddress;
        }
      }
    }

    if (spaceEmail === null) spaceEmail = '--';

    return spaceEmail;
  }
}
